module.exports = __webpack_public_path__ + "img/face-tongue.fa8daacf.png";